export enum AttributesVpRate {
  BY_PROIRITY = 'modules.expert-tool.attributes-by-proirity',
  ALWAYS = 'modules.expert-tool.attributes-always',
  ALL_MODULES = 'modules.expert-tool.attributes-all-modules',
  NONE = 'modules.expert-tool.attributes-none',
  USER_SPECIFIC = 'modules.expert-tool.attributes-user-specific',
}
